import _ from 'lodash';
import { AnyAction } from 'redux';
import ILoanPaymentAba from '~Api/LoanPaymentAba/ILoanPaymentAba';
import ILoanPaymentAbaHistory from '~Api/LoanPaymentAba/ILoanPaymentAbaHistory';
import IWarehouseLoanTransaction from '~Api/Warehouse/IWarehouseLoanTransaction';
import { IDictionary } from '~utilities/IDictionary';
import LoanPaymentAbasActionsEnum from './ActionsEnum';
import {
    ILoanPaymentAbaHistoriesSetAction,
    ILoanPaymentAbaSetAction,
    ILoanPaymentAbaWarehouseLoanTransactionsSetAction,
    ILoanPaymentAbasSetAction,
    ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsSetAction,
} from './actions';

export interface ILoanPaymentAbasState {
    histories: IDictionary<ILoanPaymentAbaHistory[]>;
    loanPaymentAbas: IDictionary<ILoanPaymentAba>;
    loanPaymentAbasListed: boolean;
    loanPaymentAbaWarehouseLoanTransactionUuids: IDictionary<string[]>;
    unallocatedWarehouseLoanTransactionUuids: string[];
}

const initialData: ILoanPaymentAbasState = {
    histories: {},
    loanPaymentAbas: {},
    loanPaymentAbasListed: false,
    loanPaymentAbaWarehouseLoanTransactionUuids: {},
    unallocatedWarehouseLoanTransactionUuids: null,
};

export function loanPaymentAbasReducer(state: ILoanPaymentAbasState = initialData, action: AnyAction): ILoanPaymentAbasState {
    switch (action.type) {
        case LoanPaymentAbasActionsEnum.LoanPaymentAbaHistoriesSet: {
            const typedAction: ILoanPaymentAbaHistoriesSetAction = action as ILoanPaymentAbaHistoriesSetAction;

            return {
                ...state,
                histories: {
                    ...state.histories,
                    [typedAction.loanPaymentAbaUuid]: typedAction.histories,
                },
            };
        }

        case LoanPaymentAbasActionsEnum.LoanPaymentAbaWarehouseLoanTransactionsSet: {
            const typedAction: ILoanPaymentAbaWarehouseLoanTransactionsSetAction = action as ILoanPaymentAbaWarehouseLoanTransactionsSetAction;

            return {
                ...state,
                loanPaymentAbaWarehouseLoanTransactionUuids: {
                    ...state.loanPaymentAbaWarehouseLoanTransactionUuids,
                    [typedAction.loanPaymentAbaUuid]: _.map(typedAction.transactions, (warehouseLoanTransaction: IWarehouseLoanTransaction) => warehouseLoanTransaction.uuid),
                },
            };
        }

        case LoanPaymentAbasActionsEnum.LoanPaymentAbasUnallocatedWarehouseLoanTransactionsSet: {
            const typedAction: ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsSetAction = action as ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsSetAction;

            return {
                ...state,
                unallocatedWarehouseLoanTransactionUuids: _.map(typedAction.transactions, (warehouseLoanTransaction: IWarehouseLoanTransaction) => warehouseLoanTransaction.uuid),
            };
        }

        case LoanPaymentAbasActionsEnum.LoanPaymentAbaSet: {
            const typedAction: ILoanPaymentAbaSetAction = action as ILoanPaymentAbaSetAction;

            return {
                ...state,
                loanPaymentAbas: {
                    ...state.loanPaymentAbas,
                    [typedAction.loanPaymentAba.uuid]: typedAction.loanPaymentAba,
                },
            };
        }

        case LoanPaymentAbasActionsEnum.LoanPaymentAbasSet: {
            const typedAction: ILoanPaymentAbasSetAction = action as ILoanPaymentAbasSetAction;

            return {
                ...state,
                loanPaymentAbas: _.keyBy(typedAction.loanPaymentAbas, 'uuid'),
                loanPaymentAbasListed: true,
            };
        }

        case LoanPaymentAbasActionsEnum.LoanPaymentAbasUnallocatedWarehouseLoanTransactionsClear: {
            return {
                ...state,
                unallocatedWarehouseLoanTransactionUuids: null,
            };
        }

        default: {
            return state;
        }
    }
}
